import React from "react";
import { required, SimpleForm, Button, ArrayField, Toolbar, SaveButton, Edit, Create, BooleanInput, Datagrid, TextField, TextInput, AutocompleteInput, ReferenceInput, BooleanField } from 'react-admin';
import EditIcon from '@material-ui/icons/Edit';

const BatchCreateToolbar = props => (
	<Toolbar {...props} >
		<SaveButton label="  Save Batch " redirect="edit" submitOnEnter={false} />
	</Toolbar>
);

const siteRenderer = (choice) => {
	if (!choice || !choice.name) return;
	return `${choice.name}  (${choice.adunit_path}) (${choice.code})`;
};
export const PlacementBatchCreate = (props) => (
	<Create title="Batch Placements" {...props}>
		<SimpleForm toolbar={<BatchCreateToolbar />} >
			<BooleanInput source="placements" label="Placements Batch?" defaultValue={true} style={{ display: 'none' }} />
			<h3>Select Parent Site</h3>
			<ReferenceInput source="site_id" label="Site" reference="sites"
				style={{ width: '400px' }}
				perPage={200}
				validate={required()}
				sort={{ field: 'name', order: 'ASC' }}
				filterToQuery={searchText => ({ search_name: searchText })}
			>
				<AutocompleteInput label="Sites" optionText={siteRenderer} optionValue="code" style={{ width: '400px' }} />
			</ReferenceInput>
			<div style={{ width: '100%' }}>
				<br /><h3>Batch Format For Placements:</h3>
		placement_name*,site_id(optional)
		</div>
			<TextInput multiline source="content" label="Sites or Placements Batch"
				initialValue=""
				fullWidth
			/>
		</SimpleForm>
	</Create>
);

const EmptyToolbar = props => (
	<Toolbar {...props} >
		<Button href="/#/batchp/" label="Back to Batch processing" variant="contained" color="primary" startIcon={<EditIcon />} />
	</Toolbar>
);
export const PlacementBatchEdit = (props) => (
	<Edit title="Batch Results" {...props} >
		<SimpleForm toolbar={<EmptyToolbar />} >
			<BooleanField source="success" label="Success?" />
			<ArrayField source="messages" label="Messages" style={{ width: '100%' }} >
				<Datagrid>
					<TextField source="message" />
				</Datagrid>
			</ArrayField>
		</SimpleForm>
	</Edit>
);
